import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import AuthShell from "../components/AuthShell/AuthShell";
import { Field } from "../components/ui";
import "./auth.css";

export default function LoginPage() {
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(event) {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(identifier.trim(), password);
      toast.ok("Signed in");
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell
      eyebrow="Sign in"
      title="Welcome back"
      sub="Generate, manage your library and open tickets."
      footer={
        <>
          No account yet? <Link to="/register">Create one</Link>
        </>
      }
    >
      <form onSubmit={onSubmit} noValidate>
        {/* The message here is the server's own - wrong password, suspended
            account - so it sits above the fields as an alert rather than
            hanging off one input that may not be the cause. */}
        {error && (
          <p className="auth-error" role="alert">
            <Icon aria-hidden="true" />
            {error}
          </p>
        )}

        <Field label="Email or username" id="identifier" required>
          <input
            id="identifier"
            type="text"
            autoComplete="username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="you@example.com"
            autoFocus
            required
          />
        </Field>

        <Field label="Password" id="password" required>
          <div className="auth-secret">
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="auth-peek"
              onClick={() => setShowPassword((v) => !v)}
              aria-pressed={showPassword}
              aria-label={showPassword ? "Hide password" : "Show password"}
              title={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </Field>

        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={busy || !identifier || !password}
        >
          {busy && <span className="spinner" aria-hidden="true" />}
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <p className="auth-disclaimer">
        Fictional data only. Not a government-issued document.
      </p>
    </AuthShell>
  );
}

/** Small inline warning glyph for the error banner. */
function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.6v5.2M12 16.2v.2" />
    </svg>
  );
}
